'use strict';

angular.module('membership')
  .controller('UserGroupDetailsCtrl', [
    '$scope', 'userGroupDetailsViewModel', '$stateParams',
    function($scope, viewModel, $stateParams) {
      $scope.viewModel = new viewModel($stateParams.action, $stateParams.groupId);
    }
  ]);